export default __webpack_public_path__ + "static/media/grafema_capitolio_06.5cbde2e6.jpg";